import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
// import testSlice from "./features/test/testSlice";
import ScheduleSlice from "./features/schedule/ScheduleSlice";
import UserSlice from "./features/user/UserSlice";
import LayoutSlice from "./features/layout/LayoutSlice";
import ScheduleNotificationSlice from "./features/notifications/scheduleNotification/ScheduleNotificationSlice";
import { PayperiodSliceReducer } from "./features/payperiod";
import { TimesheetReducer } from "./features/timesheet";
import { NotificationReducer } from "./features/notifications";
import { TimesheetV2Reducer } from "./features/timesheetv2";
import { DashboardReducer } from "./features/dashboard";
import { CommonReducer } from "./features/common";
import { TimeoffReducer } from "./features/timeoff";
import timecardReducer from "./features/timecard/timecardSlice";
import timecardDetailReducer from "./features/timecard/timecardDetailSlice";
import EmpTimecardFilterReducer from "./features/timecard/EmpTimecardFilterSlice";
import siteReducer from "./features/timecard/siteSlice";
import modalReducer from "./features/Modal/ModalSlice";
import formReducer from "./features/Form/FormSlice";
import { MobileNotificationReducer } from "./features/mobileNotifications";
import { MobileLayourReducter } from "./features/mobileLayout";
import { WorkflowReducer } from "./features/workflow";
import { TimeoffCategoryReducer } from "./features/timeoffcategory";
import { UserV2Reducer } from "./features/userv2";
import { EmployeeTimeCardReducer } from "./features/EmployeeTimeCard";
import { WhoIsInReducer } from "./features/whoIsIn";
import { UnavailabilityReducer } from "./features/unavailability";
import { GeoTrackingReducer } from "./features/geoTracking";
import { TrackingSessionsReducer } from "./features/trackingSessions";
import PunchSlice from "./features/punch/PunchSlice";
import { OpenShiftReducer } from "./features/openShift";
import { ProfileReducer } from "./features/profile";
import { scheduleV3Reducer } from "./features/scheduleV3";
import payrollFieldReducer from "./features/payrollField/slice";
import scheduleUploadReducer from "./features/scheduleUpload/scheduleUploadSlice";

export const rootReducer = combineReducers({
    schedule: ScheduleSlice,
    scheduleV3: scheduleV3Reducer,
    user: UserSlice,
    layout: LayoutSlice,
    schNotification: ScheduleNotificationSlice,
    payperiod: PayperiodSliceReducer,
    timesheet: TimesheetReducer,
    notification: NotificationReducer,
    timesheetV2: TimesheetV2Reducer,
    dashboard: DashboardReducer,
    common: CommonReducer,
    timeoff: TimeoffReducer,
    Emp_Timecard: timecardReducer,
    timecardDetails: timecardDetailReducer,
    EmpTimecardFilter: EmpTimecardFilterReducer,
    site: siteReducer,
    modal: modalReducer,
    form: formReducer,
    mobileNotifications: MobileNotificationReducer,
    mobileLayout: MobileLayourReducter,
    workflow: WorkflowReducer,
    timeoffCategory: TimeoffCategoryReducer,
    userV2: UserV2Reducer,
    employeeTimeCardData: EmployeeTimeCardReducer,
    whoIsIn: WhoIsInReducer,
    unavailability:UnavailabilityReducer,
    geoTracking:GeoTrackingReducer,
    trackingSessions: TrackingSessionsReducer,
    punch: PunchSlice,
    openShift: OpenShiftReducer,
    profile: ProfileReducer,
    payrollField: payrollFieldReducer,
    scheduleUpload: scheduleUploadReducer,
});

// $CombinedReducer, $CombinedState

// dispatch does not take types for thunks into account and thus the return type is typed incorrectly. Please use the actual Dispatch type from the store as decsribed in the documentation. Ref: https://stackoverflow.com/questions/63811401/property-then-does-not-exist-on-type-asyncthunkaction-redux-toolkit
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export const store = configureStore({
    reducer: rootReducer,
});
